module.exports = __webpack_public_path__ + "static/media/GML_light.7349a834.png";